import type { Query } from '@/client/query'

import { userVolunteerRoleDetailsFromQuery } from '@/components/Worlds/transforms/detailsFromQueries'

import BadgeDetail from './BadgeDetail'

const MONTH_YEAR_FORMAT = 'LLL yyyy'

export default function VolunteerRoleBadgeDetail({
  userVolunteerRole,
}: {
  userVolunteerRole: Query
}): JSX.Element | null {
  const { teamName, iconUrl, startDate, endDate } =
    userVolunteerRoleDetailsFromQuery(userVolunteerRole)

  const formattedStartDate = startDate.toFormat(MONTH_YEAR_FORMAT)
  const formattedEndDate = endDate == null ? null : endDate.toFormat(MONTH_YEAR_FORMAT)

  const title = `${teamName} Team`
  const subtitle =
    endDate == null
      ? `Member since ${formattedStartDate}`
      : formattedEndDate === formattedStartDate
        ? `Member during ${formattedStartDate}`
        : `Member from ${formattedStartDate} to ${formattedEndDate}`

  return <BadgeDetail title={title} subtitle={subtitle} iconUrl={iconUrl} />
}
